import { render, staticRenderFns } from "./physical_management.vue?vue&type=template&id=11bb042b&scoped=true"
import script from "./physical_management.vue?vue&type=script&lang=js"
export * from "./physical_management.vue?vue&type=script&lang=js"
import style0 from "./physical_management.vue?vue&type=style&index=0&id=11bb042b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bb042b",
  null
  
)

export default component.exports